import { Injectable } from "@angular/core";
import { ExcelExportConfig, ExcelExportService } from "./excel-configuration.service";

@Injectable({
  providedIn: 'root'
})
export class ExcelConfigService {

  constructor(private excelExportService: ExcelExportService) {}

  public exportReportToExcel<T>(
    data: T[], 
    fileName: string, 
    headers: { key: string; label: string; type?: 'number' | 'currency' | 'text' | 'date' }[], 
    totalsColumns?: string[], 
    formatters?: { [key: string]: (value: any) => string },
    calculations?: { [key: string]: 'sum' | 'avg' | 'count' },
    sortBy?: string,
    useExcelFormulas?: boolean
  ): void {
    const config: ExcelExportConfig = {
      data,
      fileName,
      headers,
      totalsConfig: totalsColumns ? {
        columns: totalsColumns,
        calculations: calculations || totalsColumns.reduce((acc, col) => {
          acc[col] = 'sum'; 
          return acc;
        }, {} as { [key: string]: 'sum' | 'avg' | 'count' }),
        useExcelFormulas: useExcelFormulas || false
      } : undefined,
      formatters,
      sortBy
    };
    
    this.excelExportService.exportToExcel(config);
  }
}